import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import * as FieldComponents from "@Shared/components/sections/index";
import MaterialInput from "@Shared/components/inputs/material-input";
import TimeInput from "@Broker/@Modules/automation/automation/components/argument-types/time";
import { mapState } from "vuex";
import PhoneInput from "@Shared/components/inputs/phone-input";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
const {
  mapFields: mapResponse
} = createHelpers({
  getterType: "getManualSubmissionResponse",
  mutationType: "setManualSubmissionResponse"
});
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LenderInformation",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MaterialInput,
    TimeInput,
    PhoneInput,
    DatepickerInput
  }),
  mixins: [validationMixin],
  props: {
    submittedApplicationId: {
      type: String,
      default: ""
    },
    responseDecision: {
      type: String,
      default: ""
    },
    lenderName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      issueDate: null,
      commitmentIssueTime: null,
      underwriter: {
        contactName: {
          contactFirstName: "",
          contactMiddleInitial: null,
          contactLastName: ""
        },
        contactPhone: {
          phoneTypeDd: 3,
          phoneNumber: ""
        }
      }
    };
  },
  validations: {
    issueDate: {
      required
    },
    commitmentIssueTime: {
      required
    },
    lenderReferenceNumber: {
      required
    },
    contactFirstName: {
      required
    },
    contactLastName: {
      required
    },
    phoneNumber: {
      required
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", {
    followUpNotificationTime(state) {
      return state.accountPreferences.followUpNotificationTime;
    }
  })), mapResponse("ApplicationStore", ["lenderReferenceNumber", "commitmentIssueDate", "underwriter.contactName.contactFirstName", "underwriter.contactName.contactLastName", "underwriter.contactPhone.phoneNumber"])), {}, {
    decisionDate() {
      return moment(this.issueDate + " " + this.commitmentIssueTime).format();
    }
  }),
  watch: {
    "$v.$invalid"(value) {
      this.$emit("validation", !value);
    },
    decisionDate(value) {
      this.commitmentIssueDate = value;
    }
  },
  mounted() {
    this.commitmentIssueTime = this.followUpNotificationTime;
  }
});